export const slotresources = {
  height: 110,
  numOfWheels: 3,
  assets: [
    { src: "damiano.png", points: -100 },
    { src: "fabio.webp", points: 1 },
    { src: "enrico.webp", points: 5 },
    { src: "canaglia.webp", points: 5 },
    { src: "peppino.webp", points: 5 },
    { src: "contadino.webp", points: 5 },
    { src: "maia.webp", points: 50 },
    { src: "annina.webp", points: 10 },
    { src: "babetti.webp", points: 7 },
    { src: "ninni.webp", points: 5 },
    { src: "saverio.webp", points: 5 },
    { src: "fusione.webp", points: 5 },
  ],
  background: {
    src: "slotMachine.png",
  },
};
